import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { styled, Box } from '@mui/material';
import { forwardRef } from 'react';
import { Header } from './components/Header.js';

const Body = forwardRef(function CardBodyComponent(_a, ref) {
    var { children, header = null, divider = false, headerTypography = {}, sxHeader = {} } = _a, rest = __rest(_a, ["children", "header", "divider", "headerTypography", "sxHeader"]);
    return (jsxs(Fragment, { children: [jsx(Header, { divider: divider, header: header, sx: sxHeader, typographyProps: headerTypography }), children ? (jsx(GridContainer, Object.assign({ ref: ref }, rest, { children: children }))) : null] }));
});
const GridContainer = styled(Box)(({ theme }) => ({
    padding: theme.spacing(1, 2.5),
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    columnGap: theme.spacing(3),
}));

export { Body };
//# sourceMappingURL=CardBody.js.map
